import { Typography, ButtonBase } from '@mui/material'
import React from 'react'

interface Props {
  handleLogout?: () => void
  buttonClass?: string
  text: string
}

const LogoutButton: React.FC<Props> = ({ handleLogout, text, buttonClass }) => {
  return (
    <ButtonBase className={buttonClass} onClick={handleLogout} data-qa={'button-header-logout'}>
      <Typography variant="body2">{text}</Typography>
    </ButtonBase>
  )
}

export default LogoutButton
